import * as React from 'react';

const ListViewSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="list-view_svg__eds-icon--list-view_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g
            id="list-view_svg__eds-icon--list-view_rows"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M4 4v4h16V4H4zm15 3H5V5h14v2zM4 14h16v-4H4v4zm1-3h14v2H5v-2zM4 20h16v-4H4v4zm1-3h14v2H5v-2z" />
        </g>
    </svg>
);

ListViewSvg.displayName = 'ListViewSvg';
export default ListViewSvg;
